import { render } from "./IconActivity.vue.js?vue&type=template&id=5bda9a1d!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconActivity.vue?vue&type=template&id=5bda9a1d"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__